<div class="custom_tab_body" style="height: 100%;">
    <form style="height: auto;align-items: center;" [formGroup]="createSetUpForm" (ngSubmit)="onViewClick()">
        <div class="row" style="padding: 2px;">
            <div class="col-md-2_4 col-sm-6 col-6" style="padding: 0px 3px ;">
                <mat-card class="contain_card">
                    <mat-form-field>
                        <input style="cursor: pointer;" matInput [matDatepicker]="stickerView"
                            placeholder="Delivery Date" (click)="stickerView.open()" [max]="currDate"
                            formControlName="fromDate" readonly required>
                        <mat-datepicker-toggle matSuffix [for]="stickerView"></mat-datepicker-toggle>
                        <mat-datepicker #stickerView disabled="false"></mat-datepicker>
                    </mat-form-field>
                </mat-card>
            </div>

            <div class="col-md-2_4 col-sm-6 col-6"  style="padding: 0px 2px 0px 0px;">
                <button type="button" id="btnnInsidePage" style="margin: 1px 2px !important; width: 97% !important;" (click)="onFetchClick()">
                    FETCH TRIP NO.
                </button>
            </div>

            <div class="col-md-2_4 col-sm-6 col-6" style="padding: 0px 3px">
                <mat-card class="contain_card">
                    <mat-form-field class="selectOption">
                        <mat-select placeholder="Select Trip No." formControlName="tripNo"
                            (selectionChange)="onTripSelect($event.value)" required>
                            <mat-option value="All" *ngIf="tripsNoList.length > 0"> All </mat-option>
                            <mat-option *ngFor="let type of tripsNoList" [value]="type">
                                {{type}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-card>
            </div>

            <div class="col-md-2_4 col-sm-6 col-6" style="padding: 0px 3px ;">
                <mat-card class="contain_card">
                    <mat-form-field class="selectOption">
                        <mat-select placeholder="Select Shipping No." formControlName="shippingNo" required>
                            <mat-option *ngFor="let type of shippingNoList" [value]="type">
                                {{type}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-card>
            </div>

            <div class="col-md-2_4 col-sm-12 col-12" style="padding: 0px ;">
                <button type="submit" id="btnnInsidePage">
                    <span class="red_color">V</span>IEW<mat-icon class="icon-style">search</mat-icon>
                </button>
            </div>
        </div>
    </form>

    <div style="height: 92%;padding: 1%;overflow: auto;">
        <div *ngFor="let data of shippingFareShippingWise" style="padding: 2px; background-color: #e8e8e8;">
            <span class="holding_span_sr">
                <p class="holding_pg_left_sr">Date</p>
                <p class="holding_pg_right_sr">: {{data.onDate}} </p>
            </span>

            <span class="holding_span_sr">
                <p class="holding_pg_left_sr">Shipping No</p>
                <p class="holding_pg_right_sr">: {{data.usedForRefNo}} </p>
            </span>

            <span class="holding_span_sr">
                <p class="holding_pg_left_sr">Against</p>
                <p class="holding_pg_right_sr">: {{data.transactionName}} </p>
            </span>

            <span class="holding_span_sr">
                <p class="holding_pg_left_sr">Pick Up Location</p>
                <p class="holding_pg_right_sr">: {{data.pickupLocation}} </p>
            </span>

            <span class="holding_span_sr">
                <p class="holding_pg_left_sr">Start Location</p>
                <p class="holding_pg_right_sr">: {{data.fromLocationName}} </p>
            </span>

            <span class="holding_span_sr">
                <p class="holding_pg_left_sr">Destination Location</p>
                <p class="holding_pg_right_sr">: {{data.toLocationName}} </p>
            </span>

            <div class="parent_div_shipping_report">
                <div class="col-md-12 col-sm-12 col-12 cart_div_shipping_report">
                    <table class="mat-elevation-z8">
                        <tr>
                            <th></th>
                            <th>Suggested</th>
                            <th>Actual</th>
                        </tr>
                        <tr style="background-color: #c5c5c5;">
                            <td>Distance</td>
                            <td>{{data.distance | number : '1.2-2'}} km</td>
                            <td>{{data.servicemanDistanceCovered | number : '1.2-2'}} km</td>
                        </tr>
                        <tr style="background-color: #c5c5c5;">
                            <td>Duration</td>
                            <td>{{data.duration | number : '1.2-2'}} min</td>
                            <td>{{data.servicemanTrafficDuration | number : '1.2-2'}} min</td>
                        </tr>
                    </table>
                </div>
            </div>

            <span class="holding_span_sr">
                <p class="holding_pg_left_sr">Weather Condition</p>
                <p class="holding_pg_right_sr">: {{data.weatherCondition}} </p>
            </span>

            <span class="holding_span_sr">
                <p class="holding_pg_left_sr">Traffic Condition</p>
                <p class="holding_pg_right_sr">: {{data.trafficCondition}} </p>
            </span>

            <span class="holding_span_sr">
                <p class="holding_pg_left_sr">Min. Pay/Delivery</p>
                <p class="holding_pg_right_sr">: &#8377;{{data.fixedPayPerKm | number : '1.2-2'}} </p>
            </span>

            <span class="holding_span_sr">
                <p class="holding_pg_left_sr">Variable Pay</p>
                <p class="holding_pg_right_sr">: &#8377;{{data.variablePay | number : '1.2-2'}} </p>
            </span>

            <span class="holding_span_sr">
                <p class="holding_pg_left_sr">Surge Pay(Weather)</p>
                <p class="holding_pg_right_sr">: &#8377;{{data.weatherPay | number : '1.2-2'}} </p>
            </span>

            <span class="holding_span_sr">
                <p class="holding_pg_left_sr">Surge Pay(Traffic)</p>
                <p class="holding_pg_right_sr">: &#8377;{{data.trafficPay | number : '1.2-2'}} </p>
            </span>

            <span class="holding_span_sr">
                <p class="holding_pg_left_sr">Surge Pay({{data.surgeName}})</p>
                <p class="holding_pg_right_sr">: &#8377;{{data.surgePay | number : '1.2-2'}} </p>
            </span>

            <span class="holding_span_sr">
                <p class="holding_pg_left_sr" style="font-weight: bold;">Net Amount</p>
                <p class="holding_pg_right_sr" style="font-weight: bold;">: &#8377;{{data.netAmount | number : '1.2-2'}}
                </p>
            </span>

            <div style="margin-top: 3%;">
                <button *ngIf="!data.disputeCurrentStatus" type="button" id="shipping_btn_shipping_report"
                    (click)="onSaveRaiseDisputeClick()">
                    Raise Dispute
                </button>
                <button *ngIf="data.disputeCurrentStatus" type="button" id="shipping_btn_shipping_report">
                    {{data.disputeCurrentStatus}}
                </button>
            </div>

        </div>
    </div>
</div>